const DEFAULT_DATE_FORMAT: { format: string; type?: 'mask' } = {
	format: 'MM/DD/YYYY',
	type: 'mask',
};
const DEFAULT_DATE_FORMAT_PLACEHOLDER = 'MM/DD/YYYY';

const DEFAULT_DATE_UAS_FORMAT_MOBILE = 'MMM D, YYYY';

export default DEFAULT_DATE_FORMAT;
export { DEFAULT_DATE_FORMAT_PLACEHOLDER, DEFAULT_DATE_UAS_FORMAT_MOBILE };
